/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_AgreeInputs */

const en_btn_agree = /** @type {(inputs: Btn_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree`)
};

/**
* | output |
* | --- |
* | "Agree" |
*
* @param {Btn_AgreeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_agree = /** @type {((inputs?: Btn_AgreeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_AgreeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_agree(inputs)
});